import React from 'react';

export const CarrotIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.46094 12.0391L2.96094 7.53906C2.65625 7.25781 2.65625 6.76562 2.96094 6.48438C3.24219 6.17969 3.73438 6.17969 4.01562 6.48438L8 10.4453L11.9609 6.48438C12.2422 6.17969 12.7344 6.17969 13.0156 6.48438C13.3203 6.76562 13.3203 7.25781 13.0156 7.53906L8.51562 12.0391C8.23438 12.3438 7.74219 12.3438 7.46094 12.0391Z"
        fill="currentColor"
      />
    </svg>
  );
};
